








import { News } from '@/models/dashboard';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewsEditView',
  data() {
    return {
      loader: {
        isNewsLoading: false,
      },
    };
  },
  async created() {
    try {
      this.loader.isNewsLoading = true;
      await this.$store.dispatch(Actions.news.fetchNewsById, this.$route.params.id);
    } finally {
      this.loader.isNewsLoading = false;
    }
  },
  computed: {
    newsToEdit(): News {
      return typedStore(this).state.news.newsToEdit;
    },
  },
});
